<template>
  <div id="app" :class="currentTheme" :style="{height: screenHeight + 'px'}">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      screenHeight: '',
    }
  },
  computed: {
    currentTheme() {
      return this.$store.getters.themeType; //获取当前的主题类型
    }
  },
  created() {
    let themeType = localStorage.getItem('themeType');
    if(!!themeType){
      let object = new Object();
      object.type = themeType;
      this.$store.dispatch('theme/changeTheme', object)
    }
  },
  watch: {
    screenHeight (val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight)
          that.timer = false
        }, 400)
      }
    }
  },
  mounted () {
    this.setWidthAndHeight();
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })()
    }
  },
  methods: {
    setWidthAndHeight() {
      this.$nextTick(() => {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
      })
    }
  }
}
</script>

<style>
  #app {
    width: 100%;
    position: relative;
    height: 100%;
    min-width: 1200px;
    min-height: 605px;
    background: #f5f6f9;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue